import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';
import { validatePassword } from '../../utils/passwordValidator';

const requirements = [
  { key: 'length', label: 'Mínimo 8 caracteres' },
  { key: 'uppercase', label: 'Pelo menos 1 letra maiúscula' },
  { key: 'lowercase', label: 'Pelo menos 1 letra minúscula' },
  { key: 'number', label: 'Pelo menos 1 número' },
  { key: 'special', label: 'Pelo menos 1 caractere especial' },
];

function PasswordStrengthChecklist({ password }) {
  const result = validatePassword(password);

  return (
    <div className="mp-password-checklist" aria-live="polite">
      <div className="mp-password-checklist__header">
        <span className="mp-password-checklist__title">Senha ideal</span>
        <span
          className={`mp-password-strength-badge ${result.isStrong ? 'is-strong' : 'is-weak'}`}
          role="status"
        >
          {result.isStrong ? 'Senha forte' : 'Senha fraca'}
        </span>
      </div>

      <div className="mp-password-checklist__list">
        {requirements.map((requirement) => {
          const valid = result[requirement.key];
          return (
            <div
              key={requirement.key}
              className={`mp-password-check ${valid ? 'is-valid' : 'is-pending'}`}
            >
              {valid ? <CheckCircle2 size={16} aria-hidden="true" /> : <Circle size={16} aria-hidden="true" />}
              <span>{requirement.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PasswordStrengthChecklist;
